import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import ColorRowPreview from '../_components/ColorRowPreview'
import type { ColorTileOption } from '../_components/ColorRowPreview/ColorRowPreview'

const useStyles = makeStyles<Theme, HottestColorsProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'HottestColors' }
)

export interface HottestColorsProps {
  classes?: StyleClasses<typeof useStyles>
}

function HottestColors(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ColorRowPreview
        title="Our Top Hottest Colors"
        description="Getting paint samples was never this easy."
        colorTileOptions={topHottestColors}
        links={[
          {
            href: 'https://samples.sherwin-williams.com/?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=samples-color-chips',
            label: 'Order Free Chips',
            theme: 'dark'
          },
          {
            href: 'https://www.sherwin-williams.com/en-us/color/color-collections/top-50-colors?utm_medium=referral&utm_source=paintscout&utm_campaign=digall-2026&utm_content=most-popular-colors',
            label: 'View All Color Chips',
            theme: 'dark'
          }
        ]}
        style={{ padding: '40px' }}
      />
    </div>
  )
}

export default HottestColors

const topHottestColors: ColorTileOption[] = [
  {
    colorTile: {
      color: '#C2C0BB',
      colorCode: '0055',
      colorName: 'Light French Gray',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EDEAE0',
      colorCode: '7008',
      colorName: 'Alabaster',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EDECE6',
      colorCode: '7005',
      colorName: 'Pure White',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#D1C7B8',
      colorCode: '7036',
      colorName: 'Accessible Beige',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#CDD2CA',
      colorCode: '6204',
      colorName: 'Sea Salt',
      tall: true,
      darkText: true
    }
  },
  {
    colorTile: {
      color: '#EDEAE5',
      colorCode: '7004',
      colorName: 'Snowbound',
      tall: true,
      darkText: true
    }
  }
]
